import React, { PropTypes, PureComponent } from 'react';
import { Table, Tip } from 'react-fast-ui';
import ColoredLabel from '../../common/components/ColoredLabel';
import TourneyName from '../TourneyName';
import Separated from '../../common/components/Separated';
import { dateFormats } from '../../util/constants';
import TourneyRecruitStatusButton from '../buttons/TourneyRecruitStatusButton';
import CityProvincePostal from '../CityProvincePostal';

const formatDate = (date) => moment(date, dateFormats.ISO_8601).format(dateFormats.MM_DD_YY);

const MISSING_COACH_INFO = (
  <Tip tip="This coach's information was not found.">
    <span className="color-fastmodel-red">***</span>
  </Tip>
);

export default class TourneyTable extends PureComponent {
  static propTypes = {
    onSort: PropTypes.func.isRequired,
    sortInfo: PropTypes.shape({
      attribute: PropTypes.string.isRequired,
      desc: PropTypes.bool.isRequired
    }),
    tourneys: PropTypes.array.isRequired,
    showAccountInfo: PropTypes.bool
  };

  static defaultProps = {
    showAccountInfo: true
  };

  render() {
    const { onSort, sortInfo, tourneys, showAccountInfo } = this.props;

    const sa = attribute => Table.th.sortAttributes(sortInfo, onSort, attribute);

    return (
      <Table>
        <Table.thead>
          <Table.th {...sa('name')}>
            Name
          </Table.th>
          <Table.th {...sa('acronym')}>
            Acronym
          </Table.th>
          <Table.th {...sa('status')} className="im_tourney-status">
            Status
          </Table.th>
          <Table.th {...sa('start')}>
            Start
          </Table.th>
          <Table.th {...sa('end')}>
            End
          </Table.th>
          <Table.th {...sa('location.city')} className="hidden-xs hidden-sm">
            Location
          </Table.th>
          {
            showAccountInfo ? (
              <Table.th className="im_tourney-attendees">
                Attendees
              </Table.th>
              ) : null
          }
          {
            showAccountInfo ? (
              <Table.th className="im_recruits-attending-header">
                # Recruits Attending
              </Table.th>
              ) : null
          }
        </Table.thead>
        <Table.tbody key="rows">
          {
            tourneys.map(tourney => {
              const { attendees, id, color, status, acronym, start, end, location } = tourney;

              return (
                <Table.tr key={id} className="align-items-center">
                  <Table.td>
                    <TourneyName tourney={tourney}/>
                  </Table.td>
                  <Table.td>
                    <ColoredLabel color={color}>{acronym}</ColoredLabel>
                  </Table.td>
                  <Table.td>
                    {status}
                  </Table.td>
                  <Table.td>
                    {formatDate(start)}
                  </Table.td>
                  <Table.td>
                    {formatDate(end)}
                  </Table.td>
                  <Table.td className="hidden-xs hidden-sm">
                    {
                      location && location.address ?
                        <CityProvincePostal city={location.address.city} province={location.address.province}/> :
                        null
                    }
                  </Table.td>
                  {
                    showAccountInfo ? (
                      <Table.td>
                        <Separated>
                          {
                            (attendees || [])
                              .map((coach, ix) =>
                                (
                                  <span key={ix}>
                                    {coach === null ? MISSING_COACH_INFO : coach.initials}
                                  </span>
                                )
                              )
                          }
                        </Separated>
                      </Table.td>
                      ) : null
                  }
                  {
                    showAccountInfo ? (
                      <Table.td>
                        <TourneyRecruitStatusButton tourney={tourney}/>
                      </Table.td>
                      ) : null
                  }
                </Table.tr>
              );
            })
          }
        </Table.tbody>
      </Table>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/tables/TourneyTable.jsx